import React, { createContext, useContext, useEffect, useState } from "react";

const dict = {
    de: {
        // Common
        app_name: "widerruf.online",
        app_tagline: "EU-konforme Widerrufsverwaltung für Onlinehändler",
        loading: "Lädt...",
        save: "Speichern",
        cancel: "Abbrechen",
        delete: "Löschen",
        edit: "Bearbeiten",
        create: "Erstellen",
        back: "Zurück",
        copy: "Kopieren",
        copied: "Kopiert!",
        // Landing
        nav_login: "Anmelden",
        nav_register: "Konto erstellen",
        hero_eyebrow: "EU-Richtlinie 2023/2673 – konform",
        hero_title: "Widerrufe rechtssicher empfangen, verwalten und dokumentieren.",
        hero_sub: "Generieren Sie einen Widerrufslink pro Shop. Empfangen Sie Anfragen über ein zentrales Dashboard. Multishop-tauglich. Made for Onlinehändler.",
        cta_start: "Jetzt starten",
        cta_demo: "Demo ansehen",
        feat_1_t: "White-Label Widerrufsseite",
        feat_1_d: "Jeder Ihrer Shops erhält einen individuellen Link mit Logo, Farbe und Adresse.",
        feat_2_t: "Multi-Shop fähig",
        feat_2_d: "Verwalten Sie mehrere Shops aus einem zentralen Konto – ohne Mehrkosten.",
        feat_3_t: "Audit-fähige Bestätigungen",
        feat_3_d: "Automatische Eingangsbestätigung per E-Mail an Ihre Kunden sowie PDF-Archiv.",
        feat_4_t: "CSV & PDF Export",
        feat_4_d: "Exportieren Sie alle Widerrufe für Buchhaltung und Steuerprüfung.",
        // Landing live demo widget
        try_live_eyebrow: "In 10 Sekunden ausprobieren",
        try_live_title: "Generieren Sie jetzt ein echtes Widerrufs-PDF.",
        try_live_sub: "Keine Anmeldung, keine Kreditkarte. Nur ein Vorgeschmack auf das, was Ihre Kunden erleben.",
        try_live_name: "Ihr Name",
        try_live_order: "Bestellnummer",
        try_live_cta: "PDF erzeugen",
        try_live_cta_loading: "Wird erzeugt …",
        try_live_success: "Fertig! Ihr Beispiel-PDF wurde heruntergeladen.",
        try_live_error: "Konnte das PDF nicht erzeugen. Bitte erneut versuchen.",
        try_live_hint: "Audit-fähig nach EU 2023/2673 · brandbar · DSGVO-konform",
        try_live_step1: "Daten eingeben",
        try_live_step2: "PDF erhalten",
        try_live_step3: "Account erstellen",
        // Auth
        login_title: "Willkommen zurück",
        login_sub: "Melden Sie sich an, um Ihr Widerrufs-Dashboard zu öffnen.",
        register_title: "Konto erstellen",
        register_sub: "30 Sekunden bis zur Aktivierung.",
        name: "Name",
        email: "E-Mail",
        password: "Passwort",
        company: "Firma (optional)",
        login_submit: "Anmelden",
        register_submit: "Konto erstellen",
        already_account: "Bereits ein Konto?",
        no_account: "Noch kein Konto?",
        login_error: "Anmeldung fehlgeschlagen",
        // Sidebar
        nav_shops: "Shops",
        nav_withdrawals: "Widerrufe",
        nav_settings: "Einstellungen",
        nav_logout: "Abmelden",
        // Shops
        shops_title: "Shops",
        shops_sub: "Verwalten Sie Ihre Stammdaten – ein Konto, beliebig viele Shops.",
        shop_add: "Shop hinzufügen",
        shop_name: "Shop-Name",
        shop_url: "Shop-URL",
        shop_company: "Firmenname",
        shop_address1: "Adresse",
        shop_address2: "Adresszusatz",
        shop_zip: "PLZ",
        shop_city: "Stadt",
        shop_country: "Land",
        shop_email: "Kontakt E-Mail",
        shop_phone: "Telefon",
        shop_logo: "Logo URL",
        shop_color: "Markenfarbe",
        shop_language: "Sprache",
        shop_vat: "USt-IdNr.",
        shop_link: "Widerrufslink",
        shop_link_copy: "Link kopieren",
        shop_no_shops_title: "Noch keine Shops",
        shop_no_shops_sub: "Legen Sie Ihren ersten Shop an, um einen Widerrufslink zu erhalten.",
        shop_notify_new_withdrawal: "Benachrichtigung bei neuem Widerruf",
        shop_notify_new_withdrawal_desc: "E-Mail erhalten, wenn ein Kunde einen neuen Widerruf einreicht.",
        shop_allow_attachments: "Datei-Uploads erlauben",
        shop_allow_attachments_desc: "Kunden können Fotos oder PDFs (z. B. Kassenbon) zum Widerruf beifügen.",
        shop_header_text_dark: "Dunkle Schrift im Header",
        shop_header_text_dark_desc: "Verwendet schwarzen Text im Formular-Header statt weißem — sinnvoll bei hellen Hintergrundfarben.",
        shop_withdrawal_period: "Widerrufsfrist",
        shop_withdrawal_period_unit: "Tage",
        error_order_not_found: "Diese Bestellnummer wurde in unserem System nicht gefunden. Bitte prüfen Sie Ihre Eingabe.",
        error_email_mismatch: "Die angegebene E-Mail-Adresse stimmt nicht mit der Bestelladresse überein.",
        error_b2b_order: "Für gewerbliche Bestellungen (B2B) besteht kein gesetzliches Widerrufsrecht.",
        error_withdrawal_period_expired: "Die Widerrufsfrist von {days} Tagen ist leider bereits abgelaufen.",
        error_withdrawal_limit_reached: "Das monatliche Widerruf-Kontingent dieses Shops ist erschöpft. Bitte kontaktieren Sie den Shop-Betreiber.",
        // Withdrawals
        wd_title: "Widerrufe",
        wd_sub: "Alle eingegangenen Widerrufsanträge aus Ihren Shops.",
        wd_export_csv: "CSV-Export",
        wd_filter_all: "Alle Shops",
        wd_filter_status_all: "Alle Status",
        wd_col_ref: "Referenz",
        wd_col_date: "Datum",
        wd_col_customer: "Kunde",
        wd_col_order: "Bestellung",
        wd_col_shop: "Shop",
        wd_col_status: "Status",
        status_new: "Neu",
        status_in_progress: "In Bearbeitung",
        status_accepted: "Akzeptiert",
        status_rejected: "Abgelehnt",
        wd_empty_title: "Keine Widerrufe vorhanden",
        wd_empty_sub: "Sobald Kunden einen Widerruf einreichen, erscheinen die Anträge hier.",
        wd_detail_title: "Widerrufsdetails",
        wd_pdf: "PDF herunterladen",
        wd_change_status: "Status ändern",
        wd_attachments: "Anhänge",
        wd_no_attachments: "Keine Anhänge",
        // Public form
        public_title: "Widerruf einreichen",
        public_sub: "Gemäß EU-Richtlinie 2023/2673 können Sie hier Ihren Widerruf erklären.",
        public_full_name: "Vollständiger Name",
        public_email: "E-Mail-Adresse",
        public_address: "Straße & Hausnummer",
        public_address2: "Adresszusatz (optional)",
        public_zip: "Postleitzahl",
        public_city: "Ort",
        public_country: "Land",
        public_order_number: "Bestellnummer",
        public_order_date: "Bestelldatum",
        public_products: "Welche Produkte/Leistungen widerrufen Sie?",
        public_reason: "Grund (freiwillig)",
        public_iban: "IBAN für Rückerstattung (optional)",
        public_attachments: "Anhänge (z.B. Rechnung)",
        public_submit: "Widerruf bestätigen",
        public_required_hint: "* Pflichtfelder",
        public_success_title: "Widerruf eingegangen",
        public_success_sub: "Wir haben Ihre Widerrufserklärung erhalten und Ihnen eine Eingangsbestätigung per E-Mail gesendet.",
        public_ref_label: "Ihre Referenz",
        public_legal: "Mit Absenden erklären Sie ausdrücklich Ihren Widerruf vom Vertrag gemäß EU-Richtlinie 2023/2673.",
        // Settings
        settings_title: "Einstellungen",
        settings_sub: "Konto- und Profileinstellungen",
        // Dashboard
        dash_stat_total: "Gesamt",
        dash_stat_new: "Neu",
        dash_stat_progress: "In Bearbeitung",
        dash_stat_done: "Erledigt",
        // Pricing
        nav_pricing: "Preise",
        nav_demo: "Demo",
        nav_billing: "Abo",
        nav_admin: "Admin",
        nav_integrations: "Integrationen",
        integrations_title: "Shop-Integrationen",
        integrations_sub: "Verbinden Sie Shopware 6, Magento 2 oder WooCommerce für automatischen Datenabgleich.",
        integration_add: "Integration hinzufügen",
        integration_edit_title: "Integration bearbeiten",
        integration_type: "Shop-System",
        integration_shop: "Shop",
        integration_base_url: "Shop-URL",
        integration_label: "Bezeichnung (optional)",
        integration_enabled: "Aktiv",
        integration_client_id: "Client ID",
        integration_client_secret: "Client Secret",
        integration_api_token: "API Token",
        integration_consumer_key: "Consumer Key",
        integration_consumer_secret: "Consumer Secret",
        integration_secret_set: "Secret gesetzt (wird nicht angezeigt)",
        integration_secret_placeholder: "Leer lassen, um bestehendes zu behalten",
        integration_test: "Verbindung testen",
        integration_test_ok: "Verbindung erfolgreich",
        integration_test_failed: "Verbindung fehlgeschlagen",
        integration_saved: "Integration gespeichert",
        integration_deleted: "Integration gelöscht",
        integration_no_integrations: "Keine Integrationen konfiguriert",
        integration_no_integrations_sub: "Verbinden Sie Shopware 6, Magento 2 oder WooCommerce mit Ihren Shops.",
        integration_delete_title: "Integration löschen?",
        integration_delete_desc: "Die Integration wird dauerhaft entfernt.",
        wd_fetch_order: "Bestellung im Shop prüfen",
        wd_shop_order_title: "Shop-System Bestellung",
        wd_shop_order_not_found: "Bestellung nicht gefunden",
        wd_shop_order_no_integration: "Kein Shop-System verbunden",
        wd_shop_order_status: "Status",
        wd_shop_order_total: "Gesamtbetrag",
        wd_shop_order_customer: "Kunde",
        wd_shop_order_items: "Positionen",
        pricing_eyebrow: "Transparente Preise",
        pricing_title: "Das passende Paket für jeden Händler",
        pricing_sub: "Starten Sie mit einem Shop oder skalieren Sie auf eine ganze Agentur. Jederzeit monatlich kündbar.",
        pricing_popular: "Beliebtester",
        pricing_per_month: "Monat",
        pricing_billed_annually: "Jährlich abgerechnet · {val}",
        pricing_cta: "Jetzt buchen",
        pricing_on_request: "Auf Anfrage",
        pricing_on_request_price: "Individuelles Angebot",
        pricing_contact_us: "Anfrage senden",
        pricing_footnote: "Alle Preise inkl. MwSt. gemäß § 19 UStG (Kleinunternehmerregelung). Sicher bezahlen via Stripe.",
        billing_monthly: "Monatlich",
        billing_yearly: "Jährlich",
        billing_processing: "Zahlung wird verarbeitet",
        billing_processing_sub: "Bitte einen Moment Geduld – wir prüfen den Zahlungsstatus...",
        billing_success_title: "Zahlung erfolgreich",
        billing_success_sub: "Ihr {plan}-Paket ist aktiv. Vielen Dank für Ihr Vertrauen!",
        billing_goto_dashboard: "Zum Dashboard",
        billing_expired: "Zahlung abgelaufen",
        billing_unknown: "Status unbekannt",
        billing_try_again: "Bitte versuchen Sie es erneut.",
        billing_back_to_plans: "Zurück zu den Paketen",
        billing_plan_none: "Kein Abo",
        billing_usage_shops: "Shops",
        billing_usage_withdrawals: "Widerrufe (Monat)",
        billing_upgrade_hint: "Upgrade für mehr Shops",
        billing_subscribe_now: "Abo abschließen",
        billing_subscription_required: "Abo erforderlich",
        billing_subscription_required_desc: "Um Shops anzulegen und Widerrufe entgegenzunehmen, benötigen Sie ein aktives Abo.",
        billing_existing_no_sub_title: "Kein aktives Abo",
        billing_existing_no_sub_desc: "Ihr Konto hat kein aktives Abo. Bestehende Shops sind sichtbar, aber neue Shops können nicht erstellt und keine Widerrufe mehr entgegengenommen werden.",
        error_subscription_required: "Für diese Aktion ist ein aktives Abo erforderlich.",
        error_shop_limit_reached: "Shop-Limit Ihres Tarifs erreicht. Bitte upgraden Sie Ihr Abo.",
        error_withdrawal_limit_reached: "Das monatliche Widerruf-Limit Ihres Tarifs wurde erreicht.",
        // Demo
        demo_eyebrow: "Live-Vorschau",
        demo_title: "So sieht Ihr Widerrufsformular aus",
        demo_sub: 'Beispielhafter Demoshop „ACME Store" – mit eigener Marke, eigenen Farben und eigenem Logo. Probieren Sie es aus.',
        demo_try_live: "Live-Formular öffnen",
        demo_footnote: "Hinweis: Einreichungen über das Demo-Formular werden nicht an einen echten Händler weitergeleitet.",
        // Toasts
        toast_welcome_back: "Willkommen zurück!",
        toast_account_created: "Konto erstellt!",
        toast_register_failed: "Registrierung fehlgeschlagen",
        toast_load_shops_failed: "Konnte Shops nicht laden",
        toast_shop_created: "Shop erstellt",
        toast_shop_updated: "Shop aktualisiert",
        toast_save_failed: "Fehler beim Speichern",
        toast_shop_deleted: "Shop gelöscht",
        toast_delete_failed: "Löschen fehlgeschlagen",
        toast_status_updated: "Status aktualisiert",
        toast_status_failed: "Status-Update fehlgeschlagen",
        toast_changes_saved: "Änderungen gespeichert",
        toast_note_saved: "Notiz gespeichert",
        toast_note_failed: "Notiz speichern fehlgeschlagen",
        toast_admin_updated: "Abo erfolgreich aktualisiert",
        admin_title: "Admin-Dashboard",
        admin_sub: "Alle Händlerkonten und deren Abonnements im Überblick.",
        admin_search: "Suche nach Name, E-Mail oder Unternehmen...",
        admin_no_merchants: "Keine Händler gefunden.",
        admin_col_account: "Konto",
        admin_col_plan: "Paket",
        admin_col_status: "Status",
        admin_col_source: "Quelle",
        admin_col_shops: "Shops",
        admin_col_withdrawals: "Widerrufe (Mo.)",
        admin_col_registered: "Registriert",
        admin_assign: "Bearbeiten",
        admin_assign_title: "Abo zuweisen",
        admin_plan_none: "Kein Abo",
        admin_status_active: "Aktiv",
        admin_status_cancelled: "Gekündigt",
        admin_billing_period: "Abrechnungszeitraum",
        admin_period_monthly: "Monatlich",
        admin_period_yearly: "Jährlich",
        admin_period_manual: "Manuell",
        toast_wd_deleted: "Widerruf gelöscht",
        toast_file_too_large: "Eine Datei ist größer als 5 MB und wurde übersprungen.",
        toast_submit_failed: "Fehler beim Absenden",
        toast_checkout_failed: "Checkout fehlgeschlagen",
        // Withdrawal detail
        wd_section_consumer: "Verbraucher",
        wd_section_order: "Bestellung",
        wd_section_history: "Bearbeitungshistorie",
        wd_history_empty: "Keine Einträge vorhanden.",
        wd_field_address1: "Adresse",
        wd_field_address2: "Adresszusatz",
        wd_field_zip: "PLZ",
        wd_field_city: "Stadt",
        wd_field_country: "Land",
        wd_field_order_no: "Bestellnummer",
        wd_field_order_date: "Bestelldatum",
        wd_field_products: "Produkte",
        wd_field_reason: "Grund",
        wd_field_iban: "IBAN",
        wd_history_created_label: "Eingegangen",
        wd_history_created_detail: "Über öffentliches Formular eingereicht",
        wd_history_status_changed: "Status geändert",
        wd_history_data_changed: "Daten geändert",
        wd_internal_note: "Interne Notiz",
        wd_internal_note_placeholder: "Nur intern sichtbar (nicht für den Kunden)",
        wd_save_note: "Notiz speichern",
        wd_meta_received: "Eingegangen",
        wd_meta_updated: "Aktualisiert",
        wd_meta_lang: "Sprache",
        wd_meta_shop: "Shop",
        wd_reject_title: "Widerruf ablehnen",
        wd_reject_desc: "Bitte geben Sie eine Begründung für die Ablehnung an. Diese wird dem Kunden per E-Mail mitgeteilt.",
        wd_reject_reason_placeholder: "Begründung der Ablehnung …",
        wd_history_rejection_reason: "Begründung",
        wd_delete_title: "Widerruf löschen?",
        wd_delete_desc: "Dies löscht den Widerruf unwiderruflich aus dem System.",
        // Shop dialog
        shop_delete_title: "Shop löschen?",
        shop_delete_desc: "Dies löscht den Shop {name} und alle zugehörigen Widerrufe unwiderruflich.",
        // Public form
        public_not_found_title: "Shop nicht gefunden",
        public_not_found_sub: "Der Widerrufslink ist ungültig oder wurde entfernt.",
        public_recipient: "Empfänger",
        public_file_hint: "PDF, JPG, PNG · max. 5 MB pro Datei",
        public_powered_by: "Powered by widerruf.online",
        // Settings
        settings_account_id: "Konto-ID",
        // Misc
        nav_lang_label: "Sprache wählen",
        // Trust badges
        trust_multishop: "Multi-Shop",
        trust_dsgvo: "DSGVO-konform",
        // Dashboard preview
        dashboard_preview: "Dashboard Preview",
        // Demo example values
        demo_ex_address: "Beispielweg 5",
        demo_ex_city: "München",
        demo_ex_products: "1 × Bluetooth-Lautsprecher (SKU-2841)",
        demo_ex_reason: "Artikel entspricht nicht der Produktbeschreibung.",
        // Footer
        footer_impressum: "Impressum",
        footer_datenschutz: "Datenschutz",
        // Email
        nav_email: "E-Mail",
        email_settings_title: "E-Mail-Postfach",
        email_settings_sub: "IMAP & SMTP für Kundenkommunikation",
        email_scope: "Geltungsbereich",
        email_scope_merchant: "Zentrales Postfach (alle Shops)",
        email_scope_shop: "Shop-spezifisch",
        email_sender: "Absender",
        email_from_email: "Absender-Adresse",
        email_from_name: "Absender-Name",
        email_enabled: "Aktiv",
        email_inbound: "Eingang",
        email_outbound: "Ausgang",
        email_host: "Server",
        email_port: "Port",
        email_user: "Benutzer",
        email_password: "Passwort",
        email_keep_existing: "leer = unverändert",
        email_use_ssl: "SSL/TLS",
        email_use_tls: "STARTTLS",
        email_test: "Verbindung testen",
        email_test_failed: "Test fehlgeschlagen",
        email_settings_saved: "E-Mail-Einstellungen gespeichert",
        email_settings_removed: "E-Mail-Einstellungen entfernt",
        email_last_poll: "Letzter Abruf",
        email_thread_title: "Kommunikation",
        email_thread_empty: "Noch keine Nachrichten. Senden Sie unten eine erste Antwort.",
        email_inbound_label: "Eingegangen",
        email_outbound_label: "Gesendet",
        email_reply_placeholder: "Ihre Antwort an den Kunden ...",
        email_attach: "Anhang",
        email_send: "Senden",
        email_sent: "E-Mail gesendet",
        // Cookie banner
        cookie_title: "Wir verwenden Cookies",
        cookie_text: "Diese Seite verwendet ausschließlich technisch notwendige Cookies, damit Login und Spracheinstellungen funktionieren. Optional setzen wir anonyme Statistik-Cookies ein, um die Plattform zu verbessern. Sie können Ihre Auswahl jederzeit unter „Einstellungen“ widerrufen.",
        cookie_accept_all: "Alle akzeptieren",
        cookie_reject: "Nur notwendige",
        cookie_settings: "Einstellungen",
        cookie_save: "Auswahl speichern",
        cookie_necessary: "Notwendig",
        cookie_necessary_desc: "Diese Cookies sind für den Betrieb (Login, Sprache) unverzichtbar.",
        cookie_analytics: "Statistik",
        cookie_analytics_desc: "Anonyme Nutzungsstatistiken zur Verbesserung der Plattform.",
        cookie_always_on: "Immer aktiv",
        cookie_more: "Mehr in der Datenschutzerklärung",
    },
    en: {
        app_name: "widerruf.online",
        app_tagline: "EU-compliant withdrawal management for online merchants",
        loading: "Loading...",
        save: "Save",
        cancel: "Cancel",
        delete: "Delete",
        edit: "Edit",
        create: "Create",
        back: "Back",
        copy: "Copy",
        copied: "Copied!",
        nav_login: "Sign in",
        nav_register: "Create account",
        hero_eyebrow: "EU Directive 2023/2673 – compliant",
        hero_title: "Receive, manage and archive withdrawals — legally compliant.",
        hero_sub: "Generate a withdrawal link per shop. Manage requests via a central dashboard. Multi-shop ready.",
        cta_start: "Get started",
        cta_demo: "See demo",
        feat_1_t: "White-label withdrawal page",
        feat_1_d: "Each of your shops gets a branded link with logo, color and address.",
        feat_2_t: "Multi-shop ready",
        feat_2_d: "Manage multiple shops from one account – no extra cost.",
        feat_3_t: "Audit-ready confirmations",
        feat_3_d: "Automatic email confirmation for customers + PDF archive.",
        feat_4_t: "CSV & PDF export",
        feat_4_d: "Export all withdrawals for accounting and audits.",
        try_live_eyebrow: "Try it live in 10 seconds",
        try_live_title: "Generate a real withdrawal PDF right now.",
        try_live_sub: "No sign-up, no credit card. Just a taste of what your customers will experience.",
        try_live_name: "Your name",
        try_live_order: "Order number",
        try_live_cta: "Generate PDF",
        try_live_cta_loading: "Generating…",
        try_live_success: "Done! Your sample PDF was downloaded.",
        try_live_error: "Could not generate the PDF. Please try again.",
        try_live_hint: "Audit-ready under EU 2023/2673 · brandable · GDPR-compliant",
        try_live_step1: "Enter details",
        try_live_step2: "Get the PDF",
        try_live_step3: "Create account",
        login_title: "Welcome back",
        login_sub: "Sign in to open your withdrawal dashboard.",
        register_title: "Create account",
        register_sub: "30 seconds to get started.",
        name: "Name",
        email: "Email",
        password: "Password",
        company: "Company (optional)",
        login_submit: "Sign in",
        register_submit: "Create account",
        already_account: "Already have an account?",
        no_account: "No account yet?",
        login_error: "Login failed",
        nav_shops: "Shops",
        nav_withdrawals: "Withdrawals",
        nav_settings: "Settings",
        nav_logout: "Logout",
        shops_title: "Shops",
        shops_sub: "Manage your shop master data – one account, unlimited shops.",
        shop_add: "Add shop",
        shop_name: "Shop name",
        shop_url: "Shop URL",
        shop_company: "Company name",
        shop_address1: "Address",
        shop_address2: "Address line 2",
        shop_zip: "Postal code",
        shop_city: "City",
        shop_country: "Country",
        shop_email: "Contact email",
        shop_phone: "Phone",
        shop_logo: "Logo URL",
        shop_color: "Brand color",
        shop_language: "Language",
        shop_vat: "VAT ID",
        shop_link: "Withdrawal link",
        shop_link_copy: "Copy link",
        shop_no_shops_title: "No shops yet",
        shop_no_shops_sub: "Create your first shop to get a withdrawal link.",
        shop_notify_new_withdrawal: "Notify on new withdrawal",
        shop_notify_new_withdrawal_desc: "Receive an email when a customer submits a new withdrawal.",
        shop_allow_attachments: "Allow file uploads",
        shop_allow_attachments_desc: "Customers can attach photos or PDFs (e.g. receipt) to their withdrawal.",
        shop_header_text_dark: "Dark header text",
        shop_header_text_dark_desc: "Uses black text in the form header instead of white — useful for light brand colors.",
        shop_withdrawal_period: "Withdrawal period",
        shop_withdrawal_period_unit: "days",
        error_order_not_found: "This order number was not found in our system. Please check your input.",
        error_email_mismatch: "The email address does not match the order's billing email.",
        error_b2b_order: "The right of withdrawal does not apply to commercial (B2B) orders.",
        error_withdrawal_period_expired: "The withdrawal period of {days} days has unfortunately already expired.",
        error_withdrawal_limit_reached: "The monthly withdrawal quota for this shop has been reached. Please contact the shop owner.",
        wd_title: "Withdrawals",
        wd_sub: "All incoming withdrawal requests from your shops.",
        wd_export_csv: "Export CSV",
        wd_filter_all: "All shops",
        wd_filter_status_all: "All statuses",
        wd_col_ref: "Reference",
        wd_col_date: "Date",
        wd_col_customer: "Customer",
        wd_col_order: "Order",
        wd_col_shop: "Shop",
        wd_col_status: "Status",
        status_new: "New",
        status_in_progress: "In progress",
        status_accepted: "Accepted",
        status_rejected: "Rejected",
        wd_empty_title: "No withdrawals yet",
        wd_empty_sub: "Once customers file a withdrawal, requests will appear here.",
        wd_detail_title: "Withdrawal details",
        wd_pdf: "Download PDF",
        wd_change_status: "Change status",
        wd_attachments: "Attachments",
        wd_no_attachments: "No attachments",
        public_title: "Submit withdrawal",
        public_sub: "Pursuant to EU Directive 2023/2673 you can declare your withdrawal here.",
        public_full_name: "Full name",
        public_email: "Email",
        public_address: "Street & number",
        public_address2: "Address line 2 (optional)",
        public_zip: "Postal code",
        public_city: "City",
        public_country: "Country",
        public_order_number: "Order number",
        public_order_date: "Order date",
        public_products: "Which products/services are you withdrawing?",
        public_reason: "Reason (optional)",
        public_iban: "IBAN for refund (optional)",
        public_attachments: "Attachments (e.g. invoice)",
        public_submit: "Confirm withdrawal",
        public_required_hint: "* Required fields",
        public_success_title: "Withdrawal received",
        public_success_sub: "We have received your withdrawal and sent you a confirmation email.",
        public_ref_label: "Your reference",
        public_legal: "By submitting you expressly declare your withdrawal from the contract per EU Directive 2023/2673.",
        settings_title: "Settings",
        settings_sub: "Account and profile settings",
        dash_stat_total: "Total",
        dash_stat_new: "New",
        dash_stat_progress: "In progress",
        dash_stat_done: "Done",
        nav_pricing: "Pricing",
        nav_demo: "Demo",
        nav_billing: "Billing",
        nav_admin: "Admin",
        nav_integrations: "Integrations",
        integrations_title: "Shop Integrations",
        integrations_sub: "Connect Shopware 6, Magento 2, or WooCommerce for automatic data sync.",
        integration_add: "Add integration",
        integration_edit_title: "Edit integration",
        integration_type: "Shop system",
        integration_shop: "Shop",
        integration_base_url: "Shop URL",
        integration_label: "Label (optional)",
        integration_enabled: "Enabled",
        integration_client_id: "Client ID",
        integration_client_secret: "Client Secret",
        integration_api_token: "API Token",
        integration_consumer_key: "Consumer Key",
        integration_consumer_secret: "Consumer Secret",
        integration_secret_set: "Secret stored (not shown)",
        integration_secret_placeholder: "Leave empty to keep existing",
        integration_test: "Test connection",
        integration_test_ok: "Connection successful",
        integration_test_failed: "Connection failed",
        integration_saved: "Integration saved",
        integration_deleted: "Integration deleted",
        integration_no_integrations: "No integrations configured",
        integration_no_integrations_sub: "Connect Shopware 6, Magento 2, or WooCommerce to your shops.",
        integration_delete_title: "Delete integration?",
        integration_delete_desc: "The integration will be permanently removed.",
        wd_fetch_order: "Check order in shop",
        wd_shop_order_title: "Shop System Order",
        wd_shop_order_not_found: "Order not found",
        wd_shop_order_no_integration: "No shop system connected",
        wd_shop_order_status: "Status",
        wd_shop_order_total: "Total",
        wd_shop_order_customer: "Customer",
        wd_shop_order_items: "Items",
        pricing_eyebrow: "Transparent pricing",
        pricing_title: "The right plan for every merchant",
        pricing_sub: "Start with one shop or scale to an entire agency. Cancel anytime.",
        pricing_popular: "Most popular",
        pricing_per_month: "month",
        pricing_billed_annually: "Billed annually · {val}",
        pricing_cta: "Book now",
        pricing_on_request: "On request",
        pricing_on_request_price: "Custom pricing",
        pricing_contact_us: "Get in touch",
        pricing_footnote: "VAT not applicable under § 19 UStG (small business regulation). Secure payments via Stripe.",
        billing_monthly: "Monthly",
        billing_yearly: "Yearly",
        billing_processing: "Processing payment",
        billing_processing_sub: "Please wait while we verify your payment status...",
        billing_success_title: "Payment successful",
        billing_success_sub: "Your {plan} plan is active. Thank you!",
        billing_goto_dashboard: "Go to dashboard",
        billing_expired: "Payment expired",
        billing_unknown: "Status unknown",
        billing_try_again: "Please try again.",
        billing_back_to_plans: "Back to plans",
        billing_plan_none: "No plan",
        billing_usage_shops: "Shops",
        billing_usage_withdrawals: "Withdrawals (month)",
        billing_upgrade_hint: "Upgrade for more shops",
        billing_subscribe_now: "Subscribe now",
        billing_subscription_required: "Subscription required",
        billing_subscription_required_desc: "You need an active subscription to create shops and receive withdrawals.",
        billing_existing_no_sub_title: "No active subscription",
        billing_existing_no_sub_desc: "Your account has no active subscription. Existing shops are visible, but new shops cannot be created and withdrawals can no longer be received.",
        error_subscription_required: "An active subscription is required for this action.",
        error_shop_limit_reached: "Shop limit of your plan reached. Please upgrade your subscription.",
        error_withdrawal_limit_reached: "The monthly withdrawal limit of your plan has been reached.",
        demo_eyebrow: "Live preview",
        demo_title: "Here is what your withdrawal form looks like",
        demo_sub: "Sample demo shop \"ACME Store\" – with its own brand, colors and logo. Try it out.",
        demo_try_live: "Open live form",
        demo_footnote: "Note: submissions made through the demo form are not forwarded to a real merchant.",
        // Toasts
        toast_welcome_back: "Welcome back!",
        toast_account_created: "Account created!",
        toast_register_failed: "Registration failed",
        toast_load_shops_failed: "Failed to load shops",
        toast_shop_created: "Shop created",
        toast_shop_updated: "Shop updated",
        toast_save_failed: "Failed to save",
        toast_shop_deleted: "Shop deleted",
        toast_delete_failed: "Failed to delete",
        toast_status_updated: "Status updated",
        toast_status_failed: "Status update failed",
        toast_changes_saved: "Changes saved",
        toast_note_saved: "Note saved",
        toast_note_failed: "Failed to save note",
        toast_admin_updated: "Subscription updated successfully",
        admin_title: "Admin Dashboard",
        admin_sub: "Overview of all merchant accounts and their subscriptions.",
        admin_search: "Search by name, email or company...",
        admin_no_merchants: "No merchants found.",
        admin_col_account: "Account",
        admin_col_plan: "Plan",
        admin_col_status: "Status",
        admin_col_source: "Source",
        admin_col_shops: "Shops",
        admin_col_withdrawals: "Withdrawals (mo.)",
        admin_col_registered: "Registered",
        admin_assign: "Edit",
        admin_assign_title: "Assign subscription",
        admin_plan_none: "No subscription",
        admin_status_active: "Active",
        admin_status_cancelled: "Cancelled",
        admin_billing_period: "Billing period",
        admin_period_monthly: "Monthly",
        admin_period_yearly: "Yearly",
        admin_period_manual: "Manual",
        toast_wd_deleted: "Withdrawal deleted",
        toast_file_too_large: "A file is larger than 5 MB and was skipped.",
        toast_submit_failed: "Submission failed",
        toast_checkout_failed: "Checkout failed",
        // Withdrawal detail
        wd_section_consumer: "Consumer",
        wd_section_order: "Order",
        wd_section_history: "Audit history",
        wd_history_empty: "No entries yet.",
        wd_field_address1: "Address",
        wd_field_address2: "Address line 2",
        wd_field_zip: "Postal code",
        wd_field_city: "City",
        wd_field_country: "Country",
        wd_field_order_no: "Order number",
        wd_field_order_date: "Order date",
        wd_field_products: "Products",
        wd_field_reason: "Reason",
        wd_field_iban: "IBAN",
        wd_history_created_label: "Received",
        wd_history_created_detail: "Submitted via public form",
        wd_history_status_changed: "Status changed",
        wd_history_data_changed: "Data updated",
        wd_internal_note: "Internal note",
        wd_internal_note_placeholder: "Visible internally only (not to the customer)",
        wd_save_note: "Save note",
        wd_meta_received: "Received",
        wd_meta_updated: "Updated",
        wd_meta_lang: "Language",
        wd_meta_shop: "Shop",
        wd_reject_title: "Reject withdrawal",
        wd_reject_desc: "Please provide a reason for the rejection. It will be included in the email sent to the customer.",
        wd_reject_reason_placeholder: "Reason for rejection …",
        wd_history_rejection_reason: "Reason",
        wd_delete_title: "Delete withdrawal?",
        wd_delete_desc: "This will permanently remove the withdrawal from the system.",
        // Shop dialog
        shop_delete_title: "Delete shop?",
        shop_delete_desc: "This will permanently delete the shop {name} and all associated withdrawals.",
        // Public form
        public_not_found_title: "Shop not found",
        public_not_found_sub: "The withdrawal link is invalid or has been removed.",
        public_recipient: "Recipient",
        public_file_hint: "PDF, JPG, PNG · max. 5 MB per file",
        public_powered_by: "Powered by widerruf.online",
        // Settings
        settings_account_id: "Account ID",
        // Misc
        nav_lang_label: "Choose language",
        trust_multishop: "Multi-Shop",
        trust_dsgvo: "GDPR compliant",
        dashboard_preview: "Dashboard preview",
        demo_ex_address: "5 Example Lane",
        demo_ex_city: "Munich",
        demo_ex_products: "1 × Bluetooth speaker (SKU-2841)",
        demo_ex_reason: "Item does not match the product description.",
        footer_impressum: "Legal notice",
        footer_datenschutz: "Privacy policy",
        // Email
        nav_email: "Email",
        email_settings_title: "Email mailbox",
        email_settings_sub: "IMAP & SMTP for customer communication",
        email_scope: "Scope",
        email_scope_merchant: "Central mailbox (all shops)",
        email_scope_shop: "Shop-specific",
        email_sender: "Sender",
        email_from_email: "Sender address",
        email_from_name: "Sender name",
        email_enabled: "Enabled",
        email_inbound: "Inbound",
        email_outbound: "Outbound",
        email_host: "Host",
        email_port: "Port",
        email_user: "Username",
        email_password: "Password",
        email_keep_existing: "blank = keep",
        email_use_ssl: "SSL/TLS",
        email_use_tls: "STARTTLS",
        email_test: "Test connection",
        email_test_failed: "Test failed",
        email_settings_saved: "Email settings saved",
        email_settings_removed: "Email settings removed",
        email_last_poll: "Last poll",
        email_thread_title: "Communication",
        email_thread_empty: "No messages yet. Send a first reply below.",
        email_inbound_label: "Received",
        email_outbound_label: "Sent",
        email_reply_placeholder: "Your reply to the customer ...",
        email_attach: "Attach",
        email_send: "Send",
        email_sent: "Email sent",
        // Cookie banner
        cookie_title: "We use cookies",
        cookie_text: "This site only uses strictly necessary cookies so that login and language preferences work. Optionally we use anonymous analytics cookies to improve the platform. You can revoke your choice at any time under \"Settings\".",
        cookie_accept_all: "Accept all",
        cookie_reject: "Necessary only",
        cookie_settings: "Settings",
        cookie_save: "Save selection",
        cookie_necessary: "Necessary",
        cookie_necessary_desc: "These cookies are required for the site to work (login, language).",
        cookie_analytics: "Analytics",
        cookie_analytics_desc: "Anonymous usage statistics to help us improve the platform.",
        cookie_always_on: "Always on",
        cookie_more: "More in our privacy policy",
    },
    fr: {
        // Common
        app_name: "widerruf.online",
        app_tagline: "Gestion des rétractations conforme à l'UE pour marchands en ligne",
        loading: "Chargement...",
        save: "Enregistrer",
        cancel: "Annuler",
        delete: "Supprimer",
        edit: "Modifier",
        create: "Créer",
        back: "Retour",
        copy: "Copier",
        copied: "Copié !",
        // Landing
        nav_login: "Connexion",
        nav_register: "Créer un compte",
        hero_eyebrow: "Conforme à la directive UE 2023/2673",
        hero_title: "Recevoir, gérer et archiver les rétractations en toute conformité.",
        hero_sub: "Générez un lien de rétractation par boutique. Gérez les demandes depuis un tableau de bord central. Multi-boutiques. Conçu pour les marchands en ligne.",
        cta_start: "Commencer",
        cta_demo: "Voir la démo",
        feat_1_t: "Page de rétractation en marque blanche",
        feat_1_d: "Chacune de vos boutiques reçoit un lien personnalisé avec logo, couleur et adresse.",
        feat_2_t: "Compatible multi-boutiques",
        feat_2_d: "Gérez plusieurs boutiques depuis un seul compte – sans coût supplémentaire.",
        feat_3_t: "Confirmations auditables",
        feat_3_d: "Confirmation automatique par e-mail pour vos clients + archive PDF.",
        feat_4_t: "Export CSV & PDF",
        feat_4_d: "Exportez toutes les rétractations pour la comptabilité et les audits.",
        try_live_eyebrow: "Essayez en 10 secondes",
        try_live_title: "Générez un vrai PDF de rétractation maintenant.",
        try_live_sub: "Sans inscription, sans carte bancaire. Un avant-goût de ce que vos clients vivront.",
        try_live_name: "Votre nom",
        try_live_order: "Numéro de commande",
        try_live_cta: "Générer le PDF",
        try_live_cta_loading: "Génération…",
        try_live_success: "Terminé ! Votre PDF de démonstration a été téléchargé.",
        try_live_error: "Impossible de générer le PDF. Veuillez réessayer.",
        try_live_hint: "Conforme UE 2023/2673 · personnalisable · conforme RGPD",
        try_live_step1: "Saisir vos infos",
        try_live_step2: "Recevoir le PDF",
        try_live_step3: "Créer un compte",
        // Auth
        login_title: "Bon retour parmi nous",
        login_sub: "Connectez-vous pour ouvrir votre tableau de bord.",
        register_title: "Créer un compte",
        register_sub: "30 secondes pour démarrer.",
        name: "Nom",
        email: "E-mail",
        password: "Mot de passe",
        company: "Société (facultatif)",
        login_submit: "Se connecter",
        register_submit: "Créer le compte",
        already_account: "Vous avez déjà un compte ?",
        no_account: "Pas encore de compte ?",
        login_error: "Échec de la connexion",
        // Sidebar
        nav_shops: "Boutiques",
        nav_withdrawals: "Rétractations",
        nav_settings: "Paramètres",
        nav_logout: "Déconnexion",
        // Shops
        shops_title: "Boutiques",
        shops_sub: "Gérez les données de vos boutiques – un compte, autant de boutiques que vous voulez.",
        shop_add: "Ajouter une boutique",
        shop_name: "Nom de la boutique",
        shop_url: "URL de la boutique",
        shop_company: "Raison sociale",
        shop_address1: "Adresse",
        shop_address2: "Complément d'adresse",
        shop_zip: "Code postal",
        shop_city: "Ville",
        shop_country: "Pays",
        shop_email: "E-mail de contact",
        shop_phone: "Téléphone",
        shop_logo: "URL du logo",
        shop_color: "Couleur de marque",
        shop_language: "Langue",
        shop_vat: "Numéro de TVA",
        shop_link: "Lien de rétractation",
        shop_link_copy: "Copier le lien",
        shop_no_shops_title: "Aucune boutique pour le moment",
        shop_no_shops_sub: "Créez votre première boutique pour obtenir un lien de rétractation.",
        shop_notify_new_withdrawal: "Notification lors d'une nouvelle rétractation",
        shop_notify_new_withdrawal_desc: "Recevoir un e-mail lorsqu'un client soumet une nouvelle rétractation.",
        shop_allow_attachments: "Autoriser les pièces jointes",
        shop_allow_attachments_desc: "Les clients peuvent joindre des photos ou des PDF (ex. reçu) à leur rétractation.",
        shop_header_text_dark: "Texte sombre dans l'en-tête",
        shop_header_text_dark_desc: "Utilise du texte noir dans l'en-tête du formulaire au lieu du blanc — utile pour les couleurs claires.",
        shop_withdrawal_period: "Délai de rétractation",
        shop_withdrawal_period_unit: "jours",
        error_order_not_found: "Ce numéro de commande est introuvable dans notre système. Veuillez vérifier votre saisie.",
        error_email_mismatch: "L'adresse e-mail ne correspond pas à l'adresse de facturation de la commande.",
        error_b2b_order: "Le droit de rétractation ne s'applique pas aux commandes professionnelles (B2B).",
        error_withdrawal_period_expired: "Le délai de rétractation de {days} jours est malheureusement déjà expiré.",
        error_withdrawal_limit_reached: "Le quota mensuel de rétractations de cette boutique est épuisé. Veuillez contacter le responsable de la boutique.",
        // Withdrawals
        wd_title: "Rétractations",
        wd_sub: "Toutes les demandes de rétractation reçues de vos boutiques.",
        wd_export_csv: "Export CSV",
        wd_filter_all: "Toutes les boutiques",
        wd_filter_status_all: "Tous les statuts",
        wd_col_ref: "Référence",
        wd_col_date: "Date",
        wd_col_customer: "Client",
        wd_col_order: "Commande",
        wd_col_shop: "Boutique",
        wd_col_status: "Statut",
        status_new: "Nouveau",
        status_in_progress: "En cours",
        status_accepted: "Accepté",
        status_rejected: "Refusé",
        wd_empty_title: "Aucune rétractation",
        wd_empty_sub: "Dès qu'un client soumet une rétractation, elle apparaîtra ici.",
        wd_detail_title: "Détails de la rétractation",
        wd_pdf: "Télécharger le PDF",
        wd_change_status: "Changer le statut",
        wd_attachments: "Pièces jointes",
        wd_no_attachments: "Aucune pièce jointe",
        // Public form
        public_title: "Soumettre une rétractation",
        public_sub: "Conformément à la directive UE 2023/2673, vous pouvez ici déclarer votre rétractation.",
        public_full_name: "Nom complet",
        public_email: "Adresse e-mail",
        public_address: "Rue et numéro",
        public_address2: "Complément d'adresse (facultatif)",
        public_zip: "Code postal",
        public_city: "Ville",
        public_country: "Pays",
        public_order_number: "Numéro de commande",
        public_order_date: "Date de commande",
        public_products: "Quels produits/services rétractez-vous ?",
        public_reason: "Motif (facultatif)",
        public_iban: "IBAN pour le remboursement (facultatif)",
        public_attachments: "Pièces jointes (ex. facture)",
        public_submit: "Confirmer la rétractation",
        public_required_hint: "* Champs obligatoires",
        public_success_title: "Rétractation reçue",
        public_success_sub: "Nous avons reçu votre déclaration et vous avons envoyé une confirmation par e-mail.",
        public_ref_label: "Votre référence",
        public_legal: "En soumettant ce formulaire, vous déclarez expressément votre rétractation du contrat conformément à la directive UE 2023/2673.",
        // Settings
        settings_title: "Paramètres",
        settings_sub: "Paramètres du compte et du profil",
        // Dashboard
        dash_stat_total: "Total",
        dash_stat_new: "Nouveau",
        dash_stat_progress: "En cours",
        dash_stat_done: "Traité",
        // Pricing
        nav_pricing: "Tarifs",
        nav_demo: "Démo",
        nav_billing: "Abonnement",
        nav_admin: "Admin",
        nav_integrations: "Intégrations",
        integrations_title: "Intégrations boutique",
        integrations_sub: "Connectez Shopware 6, Magento 2 ou WooCommerce pour la synchronisation automatique des données.",
        integration_add: "Ajouter une intégration",
        integration_edit_title: "Modifier l'intégration",
        integration_type: "Système de boutique",
        integration_shop: "Boutique",
        integration_base_url: "URL de la boutique",
        integration_label: "Libellé (optionnel)",
        integration_enabled: "Actif",
        integration_client_id: "Client ID",
        integration_client_secret: "Client Secret",
        integration_api_token: "Jeton API",
        integration_consumer_key: "Consumer Key",
        integration_consumer_secret: "Consumer Secret",
        integration_secret_set: "Secret enregistré (non affiché)",
        integration_secret_placeholder: "Laisser vide pour conserver l'existant",
        integration_test: "Tester la connexion",
        integration_test_ok: "Connexion réussie",
        integration_test_failed: "Connexion échouée",
        integration_saved: "Intégration enregistrée",
        integration_deleted: "Intégration supprimée",
        integration_no_integrations: "Aucune intégration configurée",
        integration_no_integrations_sub: "Connectez Shopware 6, Magento 2 ou WooCommerce à vos boutiques.",
        integration_delete_title: "Supprimer l'intégration ?",
        integration_delete_desc: "L'intégration sera définitivement supprimée.",
        wd_fetch_order: "Vérifier la commande dans la boutique",
        wd_shop_order_title: "Commande du système boutique",
        wd_shop_order_not_found: "Commande introuvable",
        wd_shop_order_no_integration: "Aucun système boutique connecté",
        wd_shop_order_status: "Statut",
        wd_shop_order_total: "Total",
        wd_shop_order_customer: "Client",
        wd_shop_order_items: "Articles",
        pricing_eyebrow: "Tarifs transparents",
        pricing_title: "L'offre adaptée à chaque marchand",
        pricing_sub: "Commencez avec une boutique ou passez à une agence entière. Résiliable à tout moment.",
        pricing_popular: "Le plus populaire",
        pricing_per_month: "mois",
        pricing_billed_annually: "Facturé annuellement · {val}",
        pricing_cta: "Souscrire",
        pricing_on_request: "Sur demande",
        pricing_on_request_price: "Tarif personnalisé",
        pricing_contact_us: "Nous contacter",
        pricing_footnote: "TVA non applicable selon § 19 UStG (régime des petites entreprises). Paiements sécurisés via Stripe.",
        billing_monthly: "Mensuel",
        billing_yearly: "Annuel",
        billing_processing: "Paiement en cours de traitement",
        billing_processing_sub: "Veuillez patienter pendant la vérification du statut de paiement...",
        billing_success_title: "Paiement réussi",
        billing_success_sub: "Votre formule {plan} est active. Merci pour votre confiance !",
        billing_goto_dashboard: "Vers le tableau de bord",
        billing_expired: "Paiement expiré",
        billing_unknown: "Statut inconnu",
        billing_try_again: "Veuillez réessayer.",
        billing_back_to_plans: "Retour aux offres",
        billing_plan_none: "Sans abonnement",
        billing_usage_shops: "Boutiques",
        billing_usage_withdrawals: "Rétractations (mois)",
        billing_upgrade_hint: "Passer à un plan supérieur",
        billing_subscribe_now: "Souscrire maintenant",
        billing_subscription_required: "Abonnement requis",
        billing_subscription_required_desc: "Vous avez besoin d'un abonnement actif pour créer des boutiques et recevoir des rétractations.",
        billing_existing_no_sub_title: "Pas d'abonnement actif",
        billing_existing_no_sub_desc: "Votre compte n'a pas d'abonnement actif. Les boutiques existantes sont visibles, mais il n'est plus possible de créer de nouvelles boutiques ni de recevoir de rétractations.",
        error_subscription_required: "Un abonnement actif est requis pour cette action.",
        error_shop_limit_reached: "Limite de boutiques de votre formule atteinte. Veuillez mettre à niveau votre abonnement.",
        error_withdrawal_limit_reached: "La limite mensuelle de rétractations de votre formule a été atteinte.",
        // Demo
        demo_eyebrow: "Aperçu en direct",
        demo_title: "Voici à quoi ressemble votre formulaire de rétractation",
        demo_sub: 'Boutique de démonstration « ACME Store » – avec sa propre marque, ses couleurs et son logo. Essayez-le.',
        demo_try_live: "Ouvrir le formulaire en direct",
        demo_footnote: "Remarque : les soumissions effectuées via le formulaire de démo ne sont pas transmises à un véritable marchand.",
        // Toasts
        toast_welcome_back: "Bon retour !",
        toast_account_created: "Compte créé !",
        toast_register_failed: "Échec de l'inscription",
        toast_load_shops_failed: "Impossible de charger les boutiques",
        toast_shop_created: "Boutique créée",
        toast_shop_updated: "Boutique mise à jour",
        toast_save_failed: "Échec de l'enregistrement",
        toast_shop_deleted: "Boutique supprimée",
        toast_delete_failed: "Échec de la suppression",
        toast_status_updated: "Statut mis à jour",
        toast_status_failed: "Échec de la mise à jour du statut",
        toast_changes_saved: "Modifications enregistrées",
        toast_note_saved: "Note enregistrée",
        toast_note_failed: "Échec de l'enregistrement de la note",
        toast_admin_updated: "Abonnement mis à jour avec succès",
        admin_title: "Tableau de bord Admin",
        admin_sub: "Vue d'ensemble de tous les comptes marchands et de leurs abonnements.",
        admin_search: "Rechercher par nom, e-mail ou entreprise...",
        admin_no_merchants: "Aucun marchand trouvé.",
        admin_col_account: "Compte",
        admin_col_plan: "Formule",
        admin_col_status: "Statut",
        admin_col_source: "Source",
        admin_col_shops: "Boutiques",
        admin_col_withdrawals: "Rétractations (mois)",
        admin_col_registered: "Inscrit le",
        admin_assign: "Modifier",
        admin_assign_title: "Attribuer un abonnement",
        admin_plan_none: "Aucun abonnement",
        admin_status_active: "Actif",
        admin_status_cancelled: "Résilié",
        admin_billing_period: "Période de facturation",
        admin_period_monthly: "Mensuel",
        admin_period_yearly: "Annuel",
        admin_period_manual: "Manuel",
        toast_wd_deleted: "Rétractation supprimée",
        toast_file_too_large: "Un fichier dépasse 5 Mo et a été ignoré.",
        toast_submit_failed: "Échec de l'envoi",
        toast_checkout_failed: "Échec du paiement",
        // Withdrawal detail
        wd_section_consumer: "Consommateur",
        wd_section_order: "Commande",
        wd_section_history: "Historique",
        wd_history_empty: "Aucune entrée pour le moment.",
        wd_field_address1: "Adresse",
        wd_field_address2: "Complément d'adresse",
        wd_field_zip: "Code postal",
        wd_field_city: "Ville",
        wd_field_country: "Pays",
        wd_field_order_no: "Numéro de commande",
        wd_field_order_date: "Date de commande",
        wd_field_products: "Produits",
        wd_field_reason: "Motif",
        wd_field_iban: "IBAN",
        wd_history_created_label: "Reçue",
        wd_history_created_detail: "Soumis via le formulaire public",
        wd_history_status_changed: "Statut modifié",
        wd_history_data_changed: "Données modifiées",
        wd_internal_note: "Note interne",
        wd_internal_note_placeholder: "Visible en interne uniquement (pas par le client)",
        wd_save_note: "Enregistrer la note",
        wd_meta_received: "Reçue",
        wd_meta_updated: "Mise à jour",
        wd_meta_lang: "Langue",
        wd_meta_shop: "Boutique",
        wd_reject_title: "Refuser la rétractation",
        wd_reject_desc: "Veuillez indiquer un motif de refus. Il sera communiqué au client par e-mail.",
        wd_reject_reason_placeholder: "Motif du refus …",
        wd_history_rejection_reason: "Motif",
        wd_delete_title: "Supprimer la rétractation ?",
        wd_delete_desc: "Cela supprimera définitivement la rétractation du système.",
        // Shop dialog
        shop_delete_title: "Supprimer la boutique ?",
        shop_delete_desc: "Cela supprimera définitivement la boutique {name} et toutes les rétractations associées.",
        // Public form
        public_not_found_title: "Boutique introuvable",
        public_not_found_sub: "Le lien de rétractation est invalide ou a été supprimé.",
        public_recipient: "Destinataire",
        public_file_hint: "PDF, JPG, PNG · 5 Mo max par fichier",
        public_powered_by: "Propulsé par widerruf.online",
        // Settings
        settings_account_id: "Identifiant du compte",
        // Misc
        nav_lang_label: "Choisir la langue",
        trust_multishop: "Multi-boutiques",
        trust_dsgvo: "Conforme RGPD",
        dashboard_preview: "Aperçu du tableau de bord",
        demo_ex_address: "5 rue de l'Exemple",
        demo_ex_city: "Munich",
        demo_ex_products: "1 × Enceinte Bluetooth (SKU-2841)",
        demo_ex_reason: "L'article ne correspond pas à la description.",
        footer_impressum: "Mentions légales",
        footer_datenschutz: "Confidentialité",
        // Email
        nav_email: "E-mail",
        email_settings_title: "Boîte e-mail",
        email_settings_sub: "IMAP & SMTP pour la communication client",
        email_scope: "Portée",
        email_scope_merchant: "Boîte centrale (toutes boutiques)",
        email_scope_shop: "Spécifique à la boutique",
        email_sender: "Expéditeur",
        email_from_email: "Adresse expéditeur",
        email_from_name: "Nom expéditeur",
        email_enabled: "Activé",
        email_inbound: "Entrant",
        email_outbound: "Sortant",
        email_host: "Serveur",
        email_port: "Port",
        email_user: "Utilisateur",
        email_password: "Mot de passe",
        email_keep_existing: "vide = inchangé",
        email_use_ssl: "SSL/TLS",
        email_use_tls: "STARTTLS",
        email_test: "Tester la connexion",
        email_test_failed: "Échec du test",
        email_settings_saved: "Paramètres e-mail enregistrés",
        email_settings_removed: "Paramètres supprimés",
        email_last_poll: "Dernier relevé",
        email_thread_title: "Communication",
        email_thread_empty: "Aucun message. Envoyez une première réponse ci-dessous.",
        email_inbound_label: "Reçu",
        email_outbound_label: "Envoyé",
        email_reply_placeholder: "Votre réponse au client ...",
        email_attach: "Joindre",
        email_send: "Envoyer",
        email_sent: "E-mail envoyé",
        // Cookie banner
        cookie_title: "Nous utilisons des cookies",
        cookie_text: "Ce site utilise uniquement des cookies strictement nécessaires pour que la connexion et la langue fonctionnent. En option, nous utilisons des cookies de statistiques anonymes pour améliorer la plateforme. Vous pouvez révoquer votre choix à tout moment dans « Paramètres ».",
        cookie_accept_all: "Tout accepter",
        cookie_reject: "Strictement nécessaires",
        cookie_settings: "Paramètres",
        cookie_save: "Enregistrer la sélection",
        cookie_necessary: "Nécessaires",
        cookie_necessary_desc: "Ces cookies sont indispensables au fonctionnement (connexion, langue).",
        cookie_analytics: "Statistiques",
        cookie_analytics_desc: "Statistiques d'utilisation anonymes pour améliorer la plateforme.",
        cookie_always_on: "Toujours actifs",
        cookie_more: "Plus d'informations dans la politique de confidentialité",
    },
    es: {
        // Common
        app_name: "widerruf.online",
        app_tagline: "Gestión de desistimientos conforme a la UE para comercios online",
        loading: "Cargando...",
        save: "Guardar",
        cancel: "Cancelar",
        delete: "Eliminar",
        edit: "Editar",
        create: "Crear",
        back: "Volver",
        copy: "Copiar",
        copied: "¡Copiado!",
        // Landing
        nav_login: "Iniciar sesión",
        nav_register: "Crear cuenta",
        hero_eyebrow: "Directiva UE 2023/2673 – conforme",
        hero_title: "Reciba, gestione y archive desistimientos con plena conformidad legal.",
        hero_sub: "Genere un enlace de desistimiento por tienda. Gestione las solicitudes desde un panel central. Multitivenda. Diseñado para comercios online.",
        cta_start: "Empezar ahora",
        cta_demo: "Ver demo",
        feat_1_t: "Página de desistimiento en marca blanca",
        feat_1_d: "Cada una de sus tiendas recibe un enlace personalizado con logo, color y dirección.",
        feat_2_t: "Compatible con multitivenda",
        feat_2_d: "Gestione varias tiendas desde una sola cuenta, sin coste adicional.",
        feat_3_t: "Confirmaciones auditables",
        feat_3_d: "Confirmación automática por e-mail a sus clientes + archivo en PDF.",
        feat_4_t: "Exportación CSV y PDF",
        feat_4_d: "Exporte todos los desistimientos para contabilidad y auditorías.",
        try_live_eyebrow: "Pruébelo en 10 segundos",
        try_live_title: "Genere ahora un PDF de desistimiento real.",
        try_live_sub: "Sin registro, sin tarjeta de crédito. Un adelanto de lo que vivirán sus clientes.",
        try_live_name: "Su nombre",
        try_live_order: "Número de pedido",
        try_live_cta: "Generar PDF",
        try_live_cta_loading: "Generando…",
        try_live_success: "¡Listo! Su PDF de ejemplo fue descargado.",
        try_live_error: "No se pudo generar el PDF. Inténtelo de nuevo.",
        try_live_hint: "Conforme a UE 2023/2673 · personalizable · conforme al RGPD",
        try_live_step1: "Introduzca sus datos",
        try_live_step2: "Reciba el PDF",
        try_live_step3: "Cree su cuenta",
        // Auth
        login_title: "Bienvenido de nuevo",
        login_sub: "Inicie sesión para abrir su panel de desistimientos.",
        register_title: "Crear cuenta",
        register_sub: "30 segundos para empezar.",
        name: "Nombre",
        email: "Correo electrónico",
        password: "Contraseña",
        company: "Empresa (opcional)",
        login_submit: "Iniciar sesión",
        register_submit: "Crear cuenta",
        already_account: "¿Ya tiene una cuenta?",
        no_account: "¿Aún no tiene cuenta?",
        login_error: "Error al iniciar sesión",
        // Sidebar
        nav_shops: "Tiendas",
        nav_withdrawals: "Desistimientos",
        nav_settings: "Ajustes",
        nav_logout: "Cerrar sesión",
        // Shops
        shops_title: "Tiendas",
        shops_sub: "Gestione los datos de sus tiendas – una cuenta, tantas tiendas como quiera.",
        shop_add: "Añadir tienda",
        shop_name: "Nombre de la tienda",
        shop_url: "URL de la tienda",
        shop_company: "Razón social",
        shop_address1: "Dirección",
        shop_address2: "Complemento de dirección",
        shop_zip: "Código postal",
        shop_city: "Ciudad",
        shop_country: "País",
        shop_email: "Correo de contacto",
        shop_phone: "Teléfono",
        shop_logo: "URL del logo",
        shop_color: "Color de marca",
        shop_language: "Idioma",
        shop_vat: "NIF/CIF",
        shop_link: "Enlace de desistimiento",
        shop_link_copy: "Copiar enlace",
        shop_no_shops_title: "Aún no hay tiendas",
        shop_no_shops_sub: "Cree su primera tienda para obtener un enlace de desistimiento.",
        shop_notify_new_withdrawal: "Notificar nuevo desistimiento",
        shop_notify_new_withdrawal_desc: "Reciba un correo cuando un cliente envíe un nuevo desistimiento.",
        shop_allow_attachments: "Permitir archivos adjuntos",
        shop_allow_attachments_desc: "Los clientes pueden adjuntar fotos o PDFs (p. ej. ticket) a su desistimiento.",
        shop_header_text_dark: "Texto oscuro en el encabezado",
        shop_header_text_dark_desc: "Usa texto negro en el encabezado del formulario en lugar de blanco — útil con colores de fondo claros.",
        shop_withdrawal_period: "Plazo de desistimiento",
        shop_withdrawal_period_unit: "días",
        error_order_not_found: "Este número de pedido no se encontró en nuestro sistema. Compruebe su entrada.",
        error_email_mismatch: "La dirección de correo no coincide con la del pedido.",
        error_b2b_order: "El derecho de desistimiento no se aplica a pedidos empresariales (B2B).",
        error_withdrawal_period_expired: "El plazo de desistimiento de {days} días ya ha vencido.",
        error_withdrawal_limit_reached: "Se ha alcanzado el cupo mensual de desistimientos de esta tienda. Contacte con el responsable.",
        // Withdrawals
        wd_title: "Desistimientos",
        wd_sub: "Todas las solicitudes de desistimiento recibidas de sus tiendas.",
        wd_export_csv: "Exportar CSV",
        wd_filter_all: "Todas las tiendas",
        wd_filter_status_all: "Todos los estados",
        wd_col_ref: "Referencia",
        wd_col_date: "Fecha",
        wd_col_customer: "Cliente",
        wd_col_order: "Pedido",
        wd_col_shop: "Tienda",
        wd_col_status: "Estado",
        status_new: "Nuevo",
        status_in_progress: "En proceso",
        status_accepted: "Aceptado",
        status_rejected: "Rechazado",
        wd_empty_title: "Aún no hay desistimientos",
        wd_empty_sub: "Cuando un cliente envíe un desistimiento, aparecerá aquí.",
        wd_detail_title: "Detalles del desistimiento",
        wd_pdf: "Descargar PDF",
        wd_change_status: "Cambiar estado",
        wd_attachments: "Archivos adjuntos",
        wd_no_attachments: "Sin archivos adjuntos",
        // Public form
        public_title: "Enviar desistimiento",
        public_sub: "De acuerdo con la Directiva UE 2023/2673, puede declarar aquí su desistimiento.",
        public_full_name: "Nombre completo",
        public_email: "Correo electrónico",
        public_address: "Calle y número",
        public_address2: "Complemento (opcional)",
        public_zip: "Código postal",
        public_city: "Ciudad",
        public_country: "País",
        public_order_number: "Número de pedido",
        public_order_date: "Fecha del pedido",
        public_products: "¿Qué productos/servicios desiste?",
        public_reason: "Motivo (opcional)",
        public_iban: "IBAN para el reembolso (opcional)",
        public_attachments: "Archivos adjuntos (p. ej. factura)",
        public_submit: "Confirmar desistimiento",
        public_required_hint: "* Campos obligatorios",
        public_success_title: "Desistimiento recibido",
        public_success_sub: "Hemos recibido su declaración de desistimiento y le hemos enviado un correo de confirmación.",
        public_ref_label: "Su referencia",
        public_legal: "Al enviar, declara expresamente su desistimiento del contrato conforme a la Directiva UE 2023/2673.",
        // Settings
        settings_title: "Ajustes",
        settings_sub: "Configuración de cuenta y perfil",
        // Dashboard
        dash_stat_total: "Total",
        dash_stat_new: "Nuevo",
        dash_stat_progress: "En proceso",
        dash_stat_done: "Resuelto",
        // Pricing
        nav_pricing: "Precios",
        nav_demo: "Demo",
        nav_billing: "Suscripción",
        nav_admin: "Admin",
        nav_integrations: "Integraciones",
        integrations_title: "Integraciones de tienda",
        integrations_sub: "Conecte Shopware 6, Magento 2 o WooCommerce para sincronización automática de datos.",
        integration_add: "Añadir integración",
        integration_edit_title: "Editar integración",
        integration_type: "Sistema de tienda",
        integration_shop: "Tienda",
        integration_base_url: "URL de la tienda",
        integration_label: "Etiqueta (opcional)",
        integration_enabled: "Activo",
        integration_client_id: "Client ID",
        integration_client_secret: "Client Secret",
        integration_api_token: "Token API",
        integration_consumer_key: "Consumer Key",
        integration_consumer_secret: "Consumer Secret",
        integration_secret_set: "Secret guardado (no visible)",
        integration_secret_placeholder: "Dejar vacío para conservar el existente",
        integration_test: "Probar conexión",
        integration_test_ok: "Conexión exitosa",
        integration_test_failed: "Conexión fallida",
        integration_saved: "Integración guardada",
        integration_deleted: "Integración eliminada",
        integration_no_integrations: "No hay integraciones configuradas",
        integration_no_integrations_sub: "Conecte Shopware 6, Magento 2 o WooCommerce a sus tiendas.",
        integration_delete_title: "¿Eliminar integración?",
        integration_delete_desc: "La integración será eliminada permanentemente.",
        wd_fetch_order: "Verificar pedido en la tienda",
        wd_shop_order_title: "Pedido del sistema de tienda",
        wd_shop_order_not_found: "Pedido no encontrado",
        wd_shop_order_no_integration: "No hay sistema de tienda conectado",
        wd_shop_order_status: "Estado",
        wd_shop_order_total: "Total",
        wd_shop_order_customer: "Cliente",
        wd_shop_order_items: "Artículos",
        pricing_eyebrow: "Precios transparentes",
        pricing_title: "El plan adecuado para cada comerciante",
        pricing_sub: "Empiece con una tienda o escale a toda una agencia. Cancele cuando quiera.",
        pricing_popular: "Más popular",
        pricing_per_month: "mes",
        pricing_billed_annually: "Facturado anualmente · {val}",
        pricing_cta: "Contratar",
        pricing_on_request: "Bajo solicitud",
        pricing_on_request_price: "Precio personalizado",
        pricing_contact_us: "Contactar",
        pricing_footnote: "IVA no aplicable conforme al § 19 UStG (régimen de pequeña empresa). Pagos seguros vía Stripe.",
        billing_monthly: "Mensual",
        billing_yearly: "Anual",
        billing_processing: "Procesando pago",
        billing_processing_sub: "Espere mientras verificamos el estado del pago...",
        billing_success_title: "Pago realizado",
        billing_success_sub: "Su plan {plan} está activo. ¡Gracias por su confianza!",
        billing_goto_dashboard: "Ir al panel",
        billing_expired: "Pago expirado",
        billing_unknown: "Estado desconocido",
        billing_try_again: "Por favor, inténtelo de nuevo.",
        billing_back_to_plans: "Volver a los planes",
        billing_plan_none: "Sin suscripción",
        billing_usage_shops: "Tiendas",
        billing_usage_withdrawals: "Desistimientos (mes)",
        billing_upgrade_hint: "Actualizar para más tiendas",
        billing_subscribe_now: "Suscribirse ahora",
        billing_subscription_required: "Suscripción requerida",
        billing_subscription_required_desc: "Necesita una suscripción activa para crear tiendas y recibir desistimientos.",
        billing_existing_no_sub_title: "Sin suscripción activa",
        billing_existing_no_sub_desc: "Su cuenta no tiene una suscripción activa. Las tiendas existentes son visibles, pero no se pueden crear nuevas tiendas ni recibir más desistimientos.",
        error_subscription_required: "Se necesita una suscripción activa para esta acción.",
        error_shop_limit_reached: "Límite de tiendas de su plan alcanzado. Actualice su suscripción.",
        error_withdrawal_limit_reached: "Se ha alcanzado el límite mensual de desistimientos de su plan.",
        // Demo
        demo_eyebrow: "Vista previa en vivo",
        demo_title: "Así es su formulario de desistimiento",
        demo_sub: 'Tienda de demostración «ACME Store» – con su propia marca, colores y logo. Pruébelo.',
        demo_try_live: "Abrir formulario en vivo",
        demo_footnote: "Nota: los envíos realizados a través del formulario de demo no se reenvían a un comerciante real.",
        // Toasts
        toast_welcome_back: "¡Bienvenido de nuevo!",
        toast_account_created: "¡Cuenta creada!",
        toast_register_failed: "Error en el registro",
        toast_load_shops_failed: "No se pudieron cargar las tiendas",
        toast_shop_created: "Tienda creada",
        toast_shop_updated: "Tienda actualizada",
        toast_save_failed: "Error al guardar",
        toast_shop_deleted: "Tienda eliminada",
        toast_delete_failed: "Error al eliminar",
        toast_status_updated: "Estado actualizado",
        toast_status_failed: "Error al actualizar el estado",
        toast_changes_saved: "Cambios guardados",
        toast_note_saved: "Nota guardada",
        toast_note_failed: "Error al guardar la nota",
        toast_admin_updated: "Suscripción actualizada correctamente",
        admin_title: "Panel de administración",
        admin_sub: "Resumen de todas las cuentas de comerciantes y sus suscripciones.",
        admin_search: "Buscar por nombre, correo o empresa...",
        admin_no_merchants: "No se encontraron comerciantes.",
        admin_col_account: "Cuenta",
        admin_col_plan: "Plan",
        admin_col_status: "Estado",
        admin_col_source: "Origen",
        admin_col_shops: "Tiendas",
        admin_col_withdrawals: "Desistimientos (mes)",
        admin_col_registered: "Registrado",
        admin_assign: "Editar",
        admin_assign_title: "Asignar suscripción",
        admin_plan_none: "Sin suscripción",
        admin_status_active: "Activo",
        admin_status_cancelled: "Cancelado",
        admin_billing_period: "Período de facturación",
        admin_period_monthly: "Mensual",
        admin_period_yearly: "Anual",
        admin_period_manual: "Manual",
        toast_wd_deleted: "Desistimiento eliminado",
        toast_file_too_large: "Un archivo supera los 5 MB y fue omitido.",
        toast_submit_failed: "Error al enviar",
        toast_checkout_failed: "Error en el pago",
        // Withdrawal detail
        wd_section_consumer: "Consumidor",
        wd_section_order: "Pedido",
        wd_section_history: "Historial",
        wd_history_empty: "Aún no hay entradas.",
        wd_field_address1: "Dirección",
        wd_field_address2: "Complemento",
        wd_field_zip: "Código postal",
        wd_field_city: "Ciudad",
        wd_field_country: "País",
        wd_field_order_no: "Número de pedido",
        wd_field_order_date: "Fecha del pedido",
        wd_field_products: "Productos",
        wd_field_reason: "Motivo",
        wd_field_iban: "IBAN",
        wd_history_created_label: "Recibido",
        wd_history_created_detail: "Enviado mediante formulario público",
        wd_history_status_changed: "Estado modificado",
        wd_history_data_changed: "Datos actualizados",
        wd_internal_note: "Nota interna",
        wd_internal_note_placeholder: "Solo visible internamente (no para el cliente)",
        wd_save_note: "Guardar nota",
        wd_meta_received: "Recibido",
        wd_meta_updated: "Actualizado",
        wd_meta_lang: "Idioma",
        wd_meta_shop: "Tienda",
        wd_reject_title: "Rechazar desistimiento",
        wd_reject_desc: "Indique un motivo de rechazo. Se comunicará al cliente por correo electrónico.",
        wd_reject_reason_placeholder: "Motivo del rechazo …",
        wd_history_rejection_reason: "Motivo",
        wd_delete_title: "¿Eliminar desistimiento?",
        wd_delete_desc: "Esto eliminará el desistimiento del sistema de forma permanente.",
        // Shop dialog
        shop_delete_title: "¿Eliminar tienda?",
        shop_delete_desc: "Esto eliminará permanentemente la tienda {name} y todos los desistimientos asociados.",
        // Public form
        public_not_found_title: "Tienda no encontrada",
        public_not_found_sub: "El enlace de desistimiento no es válido o ha sido eliminado.",
        public_recipient: "Destinatario",
        public_file_hint: "PDF, JPG, PNG · máx. 5 MB por archivo",
        public_powered_by: "Desarrollado por widerruf.online",
        // Settings
        settings_account_id: "ID de cuenta",
        // Misc
        nav_lang_label: "Elegir idioma",
        trust_multishop: "Multitivenda",
        trust_dsgvo: "Conforme al RGPD",
        dashboard_preview: "Vista previa del panel",
        demo_ex_address: "Calle Ejemplo 5",
        demo_ex_city: "Múnich",
        demo_ex_products: "1 × Altavoz Bluetooth (SKU-2841)",
        demo_ex_reason: "El artículo no corresponde a la descripción del producto.",
        footer_impressum: "Aviso legal",
        footer_datenschutz: "Política de privacidad",
        // Email
        nav_email: "Correo electrónico",
        email_settings_title: "Buzón de correo",
        email_settings_sub: "IMAP & SMTP para la comunicación con clientes",
        email_scope: "Alcance",
        email_scope_merchant: "Buzón central (todas las tiendas)",
        email_scope_shop: "Específico de la tienda",
        email_sender: "Remitente",
        email_from_email: "Dirección del remitente",
        email_from_name: "Nombre del remitente",
        email_enabled: "Activo",
        email_inbound: "Entrante",
        email_outbound: "Saliente",
        email_host: "Servidor",
        email_port: "Puerto",
        email_user: "Usuario",
        email_password: "Contraseña",
        email_keep_existing: "vacío = sin cambios",
        email_use_ssl: "SSL/TLS",
        email_use_tls: "STARTTLS",
        email_test: "Probar conexión",
        email_test_failed: "Prueba fallida",
        email_settings_saved: "Configuración de correo guardada",
        email_settings_removed: "Configuración de correo eliminada",
        email_last_poll: "Última consulta",
        email_thread_title: "Comunicación",
        email_thread_empty: "Aún no hay mensajes. Envíe una primera respuesta abajo.",
        email_inbound_label: "Recibido",
        email_outbound_label: "Enviado",
        email_reply_placeholder: "Su respuesta al cliente ...",
        email_attach: "Adjuntar",
        email_send: "Enviar",
        email_sent: "Correo enviado",
        // Cookie banner
        cookie_title: "Usamos cookies",
        cookie_text: "Este sitio utiliza únicamente cookies estrictamente necesarias para que el inicio de sesión y las preferencias de idioma funcionen. Opcionalmente utilizamos cookies de estadísticas anónimas para mejorar la plataforma. Puede revocar su elección en cualquier momento en «Ajustes».",
        cookie_accept_all: "Aceptar todo",
        cookie_reject: "Solo necesarias",
        cookie_settings: "Ajustes",
        cookie_save: "Guardar selección",
        cookie_necessary: "Necesarias",
        cookie_necessary_desc: "Estas cookies son imprescindibles para el funcionamiento (inicio de sesión, idioma).",
        cookie_analytics: "Estadísticas",
        cookie_analytics_desc: "Estadísticas de uso anónimas para mejorar la plataforma.",
        cookie_always_on: "Siempre activas",
        cookie_more: "Más información en la política de privacidad",
    },
};

const I18nCtx = createContext({ lang: "de", setLang: () => {}, t: (k) => k });

export function I18nProvider({ children }) {
    const [lang, setLangState] = useState(() => localStorage.getItem("wr_lang") || "de");
    const setLang = (l) => {
        localStorage.setItem("wr_lang", l);
        setLangState(l);
    };
    const t = (key, vars) => {
        let v = (dict[lang] && dict[lang][key]) || dict.de[key] || key;
        if (vars && typeof v === "string") {
            Object.keys(vars).forEach((k) => {
                v = v.replace(new RegExp(`\\{${k}\\}`, "g"), vars[k]);
            });
        }
        return v;
    };
    useEffect(() => { document.documentElement.lang = lang; }, [lang]);
    return <I18nCtx.Provider value={{ lang, setLang, t }}>{children}</I18nCtx.Provider>;
}

export function useI18n() {
    return useContext(I18nCtx);
}

// for public form (lang from shop)
export function tForLang(lang, key) {
    return (dict[lang] && dict[lang][key]) || dict.de[key] || key;
}
